import reservationTypes from '../../../session-sales/reservations/reservationTypes'
import { userEmailHydrator } from '../../../../fieldOptions/hydrators'
import { multiplierField } from '../../multiplier'

const typeOptions = [{
  value: reservationTypes.user,
  name: 'User'
}, {
  value: reservationTypes.institution,
  name: 'Institution'
}]

export default [
  {
    name: 'Type',
    prop: 'type',
    type: 'select',
    options: typeOptions
  },
  {
    name: 'User',
    prop: 'user_id',
    type: 'autocomplete',
    references: 'admin/users',
    referenceProp: 'fullname',
    dataHydrator: userEmailHydrator,
    displayProp: 'displayVal',
    showIf: resource => resource.type === reservationTypes.user
  },
  {
    name: 'Institution',
    prop: 'institution_id',
    type: 'autocomplete',
    references: 'admin/institutions',
    referenceProp: 'name',
    showIf: resource => resource.type === reservationTypes.institution
  },
  {
    name: 'Session Sale',
    prop: 'session_sale_id',
    type: 'autocomplete',
    references: 'admin/session_sales',
    referenceProp: 'title',
    displayProp: 'title',
    customFilters: { reservation_product_id_null: false },
    showIf: resource => resource.type
  },
  {
    ...multiplierField,
    showIf: resource => resource.type === reservationTypes.institution
  }
]
